import { APP_CONFIG } from 'src/app/app.config';
import { SortOrder } from 'src/app/app.constants';

export const POSITION_CONFIG = {
  requests: {
    findAllPosition: {
      name: 'findAllPosition',
      url: `${APP_CONFIG.apiBaseUrl}/position/list`,
    },
    searchPositions: {
      name: 'searchPositions',
      url: `${APP_CONFIG.apiBaseUrl}/position`,
    },
    deletePosition: {
      name: 'deletePosition',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/position/${uuid}`,
    },
    createPosition: {
      name: 'createPosition',
      url: `${APP_CONFIG.apiBaseUrl}/position`,
    },
    findPosition: {
      name: 'findPosition',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/position/${uuid}`,
    },
    getPositionByUuid: {
      name: 'getPositionByUuid',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/position/publicPage/${uuid}`,
    },
    findPositionByName: {
      name: 'findPositionByName',
      url: (name) => `${APP_CONFIG.apiBaseUrl}/position/publicPage/${name}`,
    },
    updatePosition: {
      name: 'updatePosition',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/position/${uuid}`,
    },
    findAllPublicPagePosition: {
      name: 'findAllPublicPagePosition',
      url: `${APP_CONFIG.apiBaseUrl}/position/publicPage/list`,
    },

  },
  defaultSortField: 'name',
  defaultSortOrder: SortOrder.Asc,
};
